import { connectFela } from '../../dependencies';
import ExportHeader from './ExportHeader';
import * as styles from './ExportHeader.styles';

export default connectFela(styles)(ExportHeader);
